import { createFileRoute } from '@tanstack/react-router';

import { ProjectSettingsPage } from '@/pages/project-settings/project-settings-page';
import { projectSettingsSearchSchema } from '@/pages/project-settings/project-settings-search';

export const Route = createFileRoute('/teams/$teamSlug/projects/$projectSlug_/settings')({
  validateSearch: projectSettingsSearchSchema,
  component: ProjectSettingsRoute,
});

function ProjectSettingsRoute() {
  return <ProjectSettingsPage />;
}
